import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./navcivil.css";
import { FaHome } from "react-icons/fa";

const Navcivil = () => {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    const toggleNavbar = () => {
        setIsNavbarOpen(!isNavbarOpen);
    };

    const closeNavbar = () => {
        setIsNavbarOpen(false);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark ftco-navbar-lightt" id="ftco-navbar">
            <div className="container d-flex align-items-center responsive-view justify-content-center">
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleNavbar}
                    aria-controls="ftco-nav"
                    aria-expanded={isNavbarOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="fa fa-bars"></span> Menu
                </button>
                <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="ftco-nav">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item active">
                            <Link to="/constructionpage" className="nav-link" onClick={closeNavbar} 
                            style={{ color:"#FDC30B"}}>
                                Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/about/civil" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                            About Us
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/all-service" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                              Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/all-project" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                                Project
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/ourteam" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                               Our Team
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/gallery" className="nav-link" onClick={closeNavbar}    style={{ color:"#FDC30B"}}> 
                               Gallery
                            </Link>
                        </li>

                     
                        <li className="nav-item">
                            <Link to="/real-estate" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                               Real Estate
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact" className="nav-link" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                                Contact
                            </Link>
                        </li>
                        <li className="nav-item navbar-icon-list">
                            <Link to="/" className="nav-link get-button-home" onClick={closeNavbar}     style={{ color:"#FDC30B"}}>
                               <FaHome size={20}/>
                            </Link>
                        </li>
                    </ul>
                    {/* <button className="btn-custom" data-toggle="modal" data-target="#exampleModalCenter">
                        Inquire Now
                    </button> */}
                </div>
            </div>
        </nav>
    );
};

export default Navcivil;
